//通用全局状态

const state = {
    // 访问token
    sessionToken: '662759ff-36f6-4484-8be3-8441511394af',

    // 当前查询的日期范围
    dateRange: [],

    // 当前点击的查询日期类型索引
    curDateTypeIndex: 0,
}

const actions = {

}

const getters = {
    get_sessionToken: state => state.sessionToken,
    get_dateRange: state => state.dateRange,
    get_curDateTypeIndex: state => state.curDateTypeIndex,

}


const mutations = {
    mut_sessionToken: (state, payload) => state.sessionToken = payload,
    mut_dateRange: (state, payload) => state.dateRange = payload,
    mut_curDateTypeIndex: (state, payload) => state.curDateTypeIndex = payload,
}


export default {
    namespaced: true,
    state,
    actions,
    getters,
    mutations
}
